var map = {
	"./about/战略生态合作伙伴.svg": "3428",
	"./about/注册籍会员.svg": "5bd8",
	"./about/理事会成员.svg": "d2c6",
	"./about/电话.svg": "0fe0",
	"./about/章程.svg": "f8cc",
	"./about/邮箱.svg": "6831",
	"./common/banner-button-text.svg": "38a2",
	"./common/banner-button.svg": "4498",
	"./common/banner-hover-button.svg": "81bd",
	"./common/close.svg": "4ded",
	"./common/foot-button.svg": "71bc",
	"./common/foot-hover-button.svg": "7368",
	"./common/foot-line.svg": "6886",
	"./common/ita-logo.svg": "4620",
	"./common/modal-close.svg": "8d55",
	"./common/title-black.svg": "c91d",
	"./common/title-white.svg": "0d3b",
	"./console/goldIdentificationStep.svg": "903d",
	"./console/xiaomiLogo.svg": "1d1b",
	"./console/警告项未通过.svg": "3bc0",
	"./console/认证未通过.svg": "8bd3",
	"./console/认证通过.svg": "ea42",
	"./home/ITGSA大屏设备应用适配白皮书.svg": "ee1b",
	"./home/ITGSA大屏设备应用适配白皮书6.svg": "44789",
	"./home/OPPO.svg": "e0e1",
	"./home/detail-button-hover.svg": "8b7e",
	"./home/detail-button.svg": "8e18",
	"./home/document-button-hover.svg": "f940",
	"./home/document-button.svg": "1773",
	"./home/line.svg": "42a3",
	"./home/service-icon.svg": "26c9",
	"./home/start.svg": "4256",
	"./home/vivo.svg": "91d9",
	"./home/个人信息保护标准.svg": "4597",
	"./home/兼容性标准.svg": "74374",
	"./home/兼容性标准0.svg": "df55",
	"./home/功耗标准.svg": "b54d",
	"./home/功耗标准3.svg": "f2d4",
	"./home/地震预警服务规范.svg": "c64f",
	"./home/地震预警服务规范5.svg": "383a",
	"./home/安全标准.svg": "9366",
	"./home/安全标准4.svg": "0d8a",
	"./home/小米logo.svg": "37dd",
	"./home/性能标准.svg": "b06a",
	"./home/性能标准2.svg": "3e37",
	"./home/稳定性标准.svg": "0631",
	"./home/稳定性标准1.svg": "adfa",
	"./joinus/01金标认证资格.svg": "276a",
	"./joinus/02建立行业标准参与资格.svg": "73c1",
	"./joinus/03联盟活动参与资格.svg": "45de",
	"./joinus/04应用生态优先服务资格.svg": "abe8",
	"./joinus/05领先的厂商通用服务.svg": "8136",
	"./joinus/06生态成员价值.svg": "47ab",
	"./joinus/small-line.svg": "567c",
	"./joinus/庞大的应用生态.svg": "3e94",
	"./joinus/成为战略生态合作伙伴a.svg": "9ce2",
	"./joinus/成为战略生态合作伙伴hover.svg": "573c",
	"./joinus/成为联盟注册籍会员a.svg": "15ee",
	"./joinus/成为联盟注册籍会员hover.svg": "1e01",
	"./joinus/战略合作a.svg": "fe1c",
	"./joinus/战略合作hover.svg": "b1c3",
	"./joinus/星形.svg": "3284",
	"./joinus/星形2.svg": "2636",
	"./joinus/更多权益请参阅我们的《章程》a.svg": "7b6c",
	"./joinus/更多权益请参阅我们的《章程》hover.svg": "fa6a",
	"./joinus/现在加入a.svg": "553d",
	"./joinus/现在加入hover.svg": "727f",
	"./joinus/联盟注册籍会员a.svg": "f071",
	"./joinus/联盟注册籍会员hover.svg": "a836",
	"./joinus/覆盖面极广的用户.svg": "ae4b",
	"./joinus/领先的厂商联合建立.svg": "288b",
	"./service/phone-line.svg": "2bf4",
	"./service/step-01.svg": "1408",
	"./service/step-02.svg": "7a2e",
	"./service/step-03.svg": "b34d",
	"./service/step-04.svg": "3554",
	"./service/step-05.svg": "4e8e",
	"./service/step-06.svg": "2f54",
	"./service/worth-01.svg": "c49e",
	"./service/worth-02.svg": "fc04",
	"./service/worth-03.svg": "515f",
	"./service/worth-04.svg": "2735",
	"./service/worth-05.svg": "37e4",
	"./service/发布应用.svg": "f424",
	"./service/应用市场推介.svg": "d27f",
	"./service/注册联盟账号.svg": "9c54",
	"./service/生态参与.svg": "9d9d",
	"./service/用户信任.svg": "8929",
	"./service/申请认证.svg": "4aa5",
	"./service/等待认证.svg": "9218",
	"./service/系统服务优先.svg": "5e27",
	"./service/绑定厂商账号.svg": "8bba",
	"./service/获得金标.svg": "55d3",
	"./service/行业认同.svg": "7095"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cf8d";